import { Component, OnInit, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Farm, FarmLocations, Product, Review } from '../../models/types';
import { MarketPageService } from '../services/market-page.service';
import { FormsModule } from '@angular/forms';
import { LoginService } from '../services/login.service';
import Swal from 'sweetalert2';
import { MapComponent } from "../components/map/map.component";
import { MapService } from '../services/map.service';
import { FullCalendarComponent } from "../components/full-calendar/full-calendar.component";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faMagnifyingGlass, faCow, faStar, faLocationDot, faLocationCrosshairs, faTractor, faCalendar} from '@fortawesome/free-solid-svg-icons';
import { StarRatingModule } from 'angular-star-rating';
import { ProductListComponent } from "../components/product-list/product-list.component";
import { FarmListComponent } from "../components/farm-list/farm-list.component";
import { imageLocation } from '../../environments/environment.development';

@Component({
  selector: 'app-market-page',
  standalone: true,
  imports: [CommonModule, FormsModule, MapComponent, FullCalendarComponent, FontAwesomeModule, StarRatingModule, ProductListComponent, FarmListComponent],
  templateUrl: './market-page.component.html',
  styleUrl: './market-page.component.scss'
})
export class MarketPageComponent implements OnInit{
  allFarms: Farm[] = [];
  allProductsShow: Product[] = [];
  allProducts: Product[] = [];
  filteredProducts: Product[] = [];
  productTypeFilter: string = '';
  costRangeFilter: string = '';
  searchFilter: string = '';
  farmCount: number = 0;
  prodCount: number = 0;
  farmLocations: FarmLocations[] = [];
  isOnMarketPage: boolean = true;
  currentFarm: Farm | undefined = undefined;
  ratingSortOrder: string = '';

  faMagnifyingGlass = faMagnifyingGlass;
  faCow = faCow;
  faStar = faStar;
  faLocationDot = faLocationDot;
  faLocationCrosshairs = faLocationCrosshairs;
  faTractor = faTractor;
  faCalendar = faCalendar;

  vegetableImageUrl = '../../assets/images/generic/vegetable.png';
  meatImageUrl = '../../assets/images/generic/meat.png';
  dairyImageUrl = '../../assets/images/generic/dairy.png';
  otherImageUrl = '../../assets/images/generic/other.png';

  farmDefaultImageUrl = '../../assets/images/generic/farm.png';
  constructor(
    private marketPageService: MarketPageService,
    private loginService: LoginService,
    private mapService: MapService) { }

  ngOnInit() {
    this.fetchAllFarms();
    this.fetchAllProducts();
    this.fetchAllFarmLocations();

  }

  fetchAllFarms() {
    this.marketPageService.getAllFarms().subscribe((response) => {
      this.allFarms = response.body!.farms.filter(farm => farm.farmID !== -1);
      this.farmCount = this.allFarms.length;
    });
  }

  fetchAllProducts() {
    this.marketPageService.getAllProducts().subscribe((response) => {
      this.allProductsShow = response.body!.products.map(product => {
        product.averageRating = this.calculateAverageRating(product.reviews);
        // Determine the default image based on product type
        let defaultImageUrl;
        switch (product.type) {
          case 'zelenjava':
            defaultImageUrl = this.vegetableImageUrl;
            break;
          case 'mlečni izdelek':
            defaultImageUrl = this.dairyImageUrl;
            break;
          case 'meso':
            defaultImageUrl = this.meatImageUrl;
            break;
          default:
            defaultImageUrl = this.otherImageUrl;
            break;
        }

        // Assign image URL
        if (!product.image) {
          product.image = defaultImageUrl;
        } else {
          product.image = `${imageLocation}/static/content/${product.productID}/${product.image}`;
        }

        return product;
      });

      this.prodCount = response.body!.count;
      this.allProducts = this.allProductsShow;
      console.log('All Products:', this.allProducts);
    });
  }

//Farm locations start
  fetchAllFarmLocations() {
    this.mapService.GetFarmLocations().subscribe((response) => {
      this.farmLocations = this.transformResponseToFarmLocations(response);
      console.log('Farm Locations in market-page:', this.farmLocations);
    });
  }

  transformResponseToFarmLocations(response: any): FarmLocations[] {
    const locationsObj = response.body.locations;
    const farmLocationsArray: FarmLocations[] = [];

    for (const key in locationsObj) {
      if (locationsObj.hasOwnProperty(key)) {
        farmLocationsArray.push(locationsObj[key]);
      }
    }

    return farmLocationsArray;
  }
//Farm locations end

  calculateAverageRating(reviews?: Review[]): number {
    if (reviews && reviews.length > 0) {
      const total = reviews.reduce((sum, review) => sum + review.rating, 0);
      return total / reviews.length;
    }
    return 0;
  }

  applyFilters(): void {
    this.allProductsShow = this.allProducts;
    console.log('Applying filters...');
    console.log('Product Type Filter:', this.productTypeFilter);
    console.log('Cost Range Filter:', this.costRangeFilter);
    console.log('Search Filter:', this.searchFilter);
  
    this.filteredProducts = this.allProductsShow.filter((product: Product) => {
      // Filter by product type
      if (this.productTypeFilter && product.type !== this.productTypeFilter) {
        console.log(`Filtered out ${product.name} due to product type filter`);
        return false;
      }
  
      // Filter by search term
      if (this.searchFilter && (
        !product.name.toLowerCase().includes(this.searchFilter.toLowerCase()) &&
        !product.description.toLowerCase().includes(this.searchFilter.toLowerCase())
      )) {
        console.log(`Filtered out ${product.name} due to search filter`);
        return false;
      }
  
      // Product passed all filters
      console.log(`Kept ${product.name}`);
      return true;
    });
  
    // Apply sorting by rating
    if (this.ratingSortOrder === 'asc') {
      this.filteredProducts.sort((a, b) => (a.averageRating ?? 0) - (b.averageRating ?? 0));
    } else if (this.ratingSortOrder === 'desc') {
      this.filteredProducts.sort((a, b) => (b.averageRating ?? 0) - (a.averageRating ?? 0));
    }
  
    console.log('Filtered Products:', this.filteredProducts);
    this.allProductsShow = this.filteredProducts;
  }
  
  clearFilters(): void {
    this.productTypeFilter = '';
    this.costRangeFilter = '';
    this.searchFilter = '';
    this.allProductsShow = this.allProducts;
  }
  
}
